import slide1 from './slider/slide1.jpg';
import slide2 from './slider/slide2.jpg';

export default [slide1, slide2];
